import { fmtDateTimeFR } from '../../utils/dates';

export const fmtDate = (iso) => {
  if (!iso) return 'Jamais';
  return fmtDateTimeFR(iso) || '-';
};

export const buildInviteUrl = (token) => `${window.location.origin}/invitation/${token}`;
